<div class="page-container">
  <h3>Add Log</h3>
  <div>
    <ion-item>
      <ion-label>Visit Date</ion-label>
      <ion-input value="{{ newVisit.VisitDate | date: 'short' }}" id="logdate" class="ion-text-end"
        labelPlacement="stacked" readonly="true"></ion-input>
      <ion-popover trigger="logdate" size="cover">
        <ng-template>
          <ion-datetime presentation="datetime" [showDefaultButtons]="true" #logDate
            (ionChange)="setLogDate(logDate.value)">
          </ion-datetime>
        </ng-template>
      </ion-popover>
    </ion-item>
    <ion-item>
      <ion-label>Reminder Date</ion-label>
      <ion-input value="{{ newVisit.ReminderDate | date: 'short' }}" id="reminderDate" class="ion-text-end"
        labelPlacement="stacked" readonly="true"></ion-input>
      <ion-popover trigger="reminderDate" size="cover">
        <ng-template>
          <ion-datetime presentation="datetime" [showDefaultButtons]="true" #reminderDate
            (ionChange)="setReminderDate(reminderDate.value)">
          </ion-datetime>
        </ng-template>
      </ion-popover>
    </ion-item>
    <ion-item>
      <ion-textarea label="Comment" placeholder="Comment" [(ngModel)]="newVisit.Comment"></ion-textarea>
    </ion-item>
  </div>

  <ion-button expand="full" size="medium" (click)="saveVisit(newVisit)">Save</ion-button>

  <h3>Log History</h3>
  <ion-item *ngIf="lstVisitLogs.length === 0">
    No Logs
  </ion-item>
  <div *ngIf="lstVisitLogs.length > 0">
    <ion-accordion-group>
      <ion-accordion *ngFor="let log of lstVisitLogs">
        <ion-item slot="header" color="light">
          <ion-label>{{log.VisitDate | date: 'MM/dd/yy'}}</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">{{log.Comment}} - <small class="bold">{{log.CreatedByName}}</small>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </div>
</div>